import * as React from "react";
import type { SVGProps } from "react";
const SvgPaypal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <g fillRule="evenodd" clipPath="url(#paypal_svg__a)" clipRule="evenodd">
      <path
        fill="#238ec2"
        d="M18.313 7.097c.244-1.554-.002-2.612-.846-3.57-.928-1.054-2.606-1.506-4.753-1.506H6.482a.89.89 0 0 0-.88.75L3.007 19.167c-.052.324.2.616.528.616h3.847l-.265 1.678a.467.467 0 0 0 .462.539h3.242a.78.78 0 0 0 .77-.656l.033-.164.61-3.86.04-.213a.78.78 0 0 1 .77-.656h.485c3.142 0 5.602-1.272 6.32-4.95.3-1.537.145-2.82-.649-3.722a3.1 3.1 0 0 0-.887-.682"
      />
      <path
        fill="#20274f"
        d="M18.313 7.097c.244-1.554-.002-2.612-.846-3.57-.928-1.054-2.606-1.506-4.753-1.506H6.482a.89.89 0 0 0-.88.75L3.007 19.167c-.052.324.2.616.528.616h3.847l.966-6.106-.03.192a.89.89 0 0 1 .878-.75h1.829c3.59 0 6.402-1.454 7.224-5.658q.036-.187.064-.364"
      />
      <path
        fill="#253667"
        d="M9.387 7.118a.78.78 0 0 1 .77-.657h4.885q.87 0 1.611.117a7 7 0 0 1 .8.177 5 5 0 0 1 .86.342c.244-1.554-.002-2.612-.846-3.57-.928-1.054-2.606-1.506-4.753-1.506H6.482a.89.89 0 0 0-.88.75L3.007 19.167c-.052.324.2.616.528.616h3.847z"
      />
    </g>
    <defs>
      <clipPath id="paypal_svg__a">
        <path fill="#fff" d="M3 2h17.008v20H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPaypal;
